<script setup lang="ts">
import { type TCountryCode, countries } from 'countries-list';

withDefaults(
  defineProps<{
    options?: TCountryCode[];
  }>(),
  {
    options: () => Object.keys(countries) as TCountryCode[],
  },
);

const countryCode = defineModel<TCountryCode>({ required: true });
</script>

<template>
  <PDropdown
    v-model="countryCode"
    :options="options"
    placeholder="Select a Country"
    checkmark
    append-to="self"
  >
    <template #value="{ value, placeholder }">
      <span class="inline-flex items-center">
        <NuxtImg :src="`https://purecatamphetamine.github.io/country-flag-icons/3x2/${value}.svg`" loading="lazy" alt="" class="inline-block w-6 h-4 mr-2" />
        {{ value ? countries[value as TCountryCode].name : placeholder }}
      </span>
    </template>
    <template #option="{ option }">
      <span class="inline-flex items-center space-x-2">
        <NuxtImg :src="`https://purecatamphetamine.github.io/country-flag-icons/3x2/${option}.svg`" loading="lazy" alt="" class="inline-block w-6 h-4 mr-2" />
        {{ countries[option as TCountryCode].name }}
      </span>
    </template>
  </PDropdown>
</template>
